// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
var lineSlotClass = "Hero_heroLineSlot__nV0pL";
var lineSizerClass = "Hero_heroLineSizer__nV0pL";
var lineTypingClass = "Hero_heroLineTyping__nV0pL";
var lineClass = "Hero_heroLine__nV0pL";
let particleColor = "#3e4f2a";
let particleFont = "Amiri, serif";
function hexToRgb(e) {
  let t = e.replace("#", "");
  return {
    r: Number.parseInt(t.slice(0, 2), 16),
    g: Number.parseInt(t.slice(2, 4), 16),
    b: Number.parseInt(t.slice(4, 6), 16),
  };
}
function clamp(e, t, i) {
  return Math.min(Math.max(e, t), i);
}
function ParticleText({ text: text, onLayout: onLayout }) {
  let containerRef = (0, React.useRef)(null),
    canvasRef = (0, React.useRef)(null),
    layoutCallbackRef = (0, React.useRef)(onLayout);
  return (
    (layoutCallbackRef.current = onLayout),
    (0, React.useEffect)(() => {
      let t = containerRef.current,
        n = canvasRef.current;
      if (!t || !n) return () => {};
      let r = n.getContext("2d");
      if (!r) return () => {};
      !(function () {
        if (document.querySelector("link[data-amiri-font]")) return;
        let e = document.createElement("link");
        ((e.rel = "stylesheet"),
          (e.href = "/external/amiri.css"),
          (e.dataset.amiriFont = "true"),
          document.head.append(e));
      })();
      let l =
          "function" == typeof window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        s = [],
        c = null,
        d = null,
        u = false,
        p = 0,
        m = 0,
        h = 0,
        g = {
          active: false,
          x: 0,
          y: 0,
          sx: 0,
          sy: 0,
        },
        f = null;
      function M(e) {
        (r.clearRect(0, 0, m, h),
          (g.sx += (g.x - g.sx) * 0.18),
          (g.sy += (g.y - g.sy) * 0.18));
        let t = true;
        for (let i of s) {
          let n = i.tx,
            o = i.ty,
            a = 1;
          if (u) {
            let r = 1 - (1 - (a = clamp((e - p - i.delay) / 1600, 0, 1))) ** 3;
            ((n = i.sx + (i.tx - i.sx) * r),
              (o = i.sy + (i.ty - i.sy) * r),
              a < 1 && (t = false));
          } else if (!l) {
            let t = 0.001 * e;
            ((n += 0.15 * Math.sin(0.9 * t + 10 * i.seed) * i.depth),
              (o += 0.15 * Math.cos(0.75 * t + 10 * i.depth) * i.depth));
          }
          if (g.active) {
            let e = i.x - g.sx,
              t = i.y - g.sy,
              a = Math.hypot(e, t);
            if (a < 120 && a > 0.1) {
              let i = (1 - a / 120) * 40;
              ((n += (e / a) * i), (o += (t / a) * i));
            }
          }
          ((i.x += (n - i.x) * 0.55),
            (i.y += (o - i.y) * 0.55),
            (r.globalAlpha = clamp(0.35 + 0.65 * a, 0, 1)),
            (r.fillStyle = i.color),
            i.size <= 2.1
              ? r.fillRect(i.x - i.size / 2, i.y - i.size / 2, i.size, i.size)
              : (r.beginPath(),
                r.arc(i.x, i.y, i.size / 2, 0, 2 * Math.PI),
                r.fill()));
        }
        ((r.globalAlpha = 1),
          (r.shadowBlur = 0),
          u && t && (u = false),
          (c = l ? null : requestAnimationFrame(M)));
      }
      function y() {
        let i,
          o,
          d = t.getBoundingClientRect();
        if (
          ((m = Math.floor(d.width)),
          (h = Math.floor(d.height)),
          m <= 0 || h <= 0)
        )
          return;
        let f = Math.min(window.devicePixelRatio || 1, 2);
        ((n.width = Math.floor(m * f)),
          (n.height = Math.floor(h * f)),
          (n.style.width = "100%"),
          (n.style.height = "100%"),
          r.setTransform(f, 0, 0, f, 0, 0));
        let y =
            (((i = document.createElement("span")).textContent = "M"),
            (i.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;font-size:clamp(6rem, 18vw, 14rem);font-weight:400;font-family:${particleFont}`),
            t.append(i),
            (o = Number.parseFloat(window.getComputedStyle(i).fontSize) || 96),
            i.remove(),
            o),
          x = `400 ${y}px ${particleFont}`,
          N = document.createElement("canvas"),
          b = N.getContext("2d", {
            willReadFrequently: true,
          });
        if (!b) return;
        let k = 0.92 * m;
        b.font = x;
        let T = b.measureText(text),
          C = Math.max(1, T.width);
        C > k &&
          ((y = Math.max(18, (k / C) * y)),
          (b.font = x = `400 ${y}px ${particleFont}`),
          (T = b.measureText(text)));
        let w = Math.ceil(T.actualBoundingBoxLeft || 0),
          A = Math.ceil(T.actualBoundingBoxRight || T.width),
          D = Math.ceil(T.actualBoundingBoxAscent || 0.78 * y),
          j = Math.ceil(T.actualBoundingBoxDescent || 0.22 * y),
          v = Math.max(12, Math.ceil(0.08 * y)),
          I = Math.max(1, D + j);
        ((N.width = Math.max(1, w + A) + 2 * v),
          (N.height = I + 2 * v),
          b.clearRect(0, 0, N.width, N.height),
          (b.font = x),
          (b.textAlign = "left"),
          (b.textBaseline = "alphabetic"),
          (b.fillStyle = "#fff"),
          b.fillText(text, v - w, v + D));
        let P = b.getImageData(0, 0, N.width, N.height),
          S = [],
          z = Math.max(2, Math.floor(1));
        for (let e = 0; e < N.height; e += z)
          for (let t = 0; t < N.width; t += z) {
            let i = P.data[(e * N.width + t) * 4 + 3];
            i > 40 &&
              S.push({
                x: m / 2 - N.width / 2 + t,
                y: h / 2 - N.height / 2 + e,
                a: i / 255,
              });
          }
        let L = Math.max(900, Math.min(5200, Math.floor((m * h) / 90))),
          E = Math.max(1, Math.ceil(S.length / L)),
          O = hexToRgb("#2d3a1e"),
          U = hexToRgb(particleColor);
        if (
          ((s = S.filter((e, t) => t % E == 0).map((e, t) => {
            var i;
            let n = ((9301 * t + 49297) % 233280) / 233280,
              o = 0.45 + (((233 * t + 97) % 1e3) / 1e3) * 0.9,
              a = clamp(e.x / Math.max(1, m) + (n - 0.5) * 0.35, 0, 1),
              r =
                ((i = {
                  r: Math.round(O.r + (U.r - O.r) * a),
                  g: Math.round(O.g + (U.g - O.g) * a),
                  b: Math.round(O.b + (U.b - O.b) * a),
                }),
                `rgb(${i.r},${i.g},${i.b})`),
              l = n * Math.PI * 2,
              s = 180 * (0.35 + 0.75 * o),
              c = e.x + Math.cos(l) * s + (n - 0.5) * 81,
              d = e.y + Math.sin(l) * s + (o - 0.9) * 81;
            return {
              x: c,
              y: d,
              sx: c,
              sy: d,
              tx: e.x,
              ty: e.y,
              size: 1.8,
              color: r,
              seed: n,
              depth: o,
              delay: 420 * n,
            };
          })),
          (g.x = m / 2),
          (g.y = h / 2),
          (g.sx = g.x),
          (g.sy = g.y),
          l)
        ) {
          for (let e of s) ((e.x = e.tx), (e.y = e.ty));
          u = false;
        } else
          !(function (e) {
            if (0 === s.length) return;
            let t = performance.now();
            for (let t of s) {
              if (e) {
                let e = t.seed * Math.PI * 2,
                  i = 180 * (0.35 + 0.75 * t.depth);
                ((t.x = t.tx + Math.cos(e) * i + (t.depth - 0.5) * 180 * 0.55),
                  (t.y = t.ty + Math.sin(e) * i + (t.seed - 0.5) * 180 * 0.55));
              }
              ((t.sx = t.x), (t.sy = t.y), (t.delay = 420 * t.seed));
            }
            ((p = t), (u = true));
          })(false);
        (layoutCallbackRef.current?.(h / 2 + N.height / 2),
          null === c && (c = requestAnimationFrame(M)));
      }
      function x() {
        (d && cancelAnimationFrame(d),
          (d = requestAnimationFrame(() => {
            (document.fonts?.ready ?? Promise.resolve()).then(y);
          })));
      }
      let N = new ResizeObserver(x);
      (N.observe(t), x());
      let b = (e) => {
          let i = t.getBoundingClientRect();
          ((g.x = e.clientX - i.left), (g.y = e.clientY - i.top));
        },
        k = (e) => {
          "mouse" !== e.pointerType &&
            ((f = e.pointerId), b(e), (g.active = true));
        },
        T = (e) => {
          if ("mouse" === e.pointerType) {
            (b(e), (g.active = true));
            return;
          }
          e.pointerId === f && b(e);
        },
        C = (e) => {
          "mouse" === e.pointerType ||
            (e.pointerId === f && ((f = null), (g.active = false)));
        },
        w = (e) => {
          "mouse" === e.pointerType && (g.active = false);
        };
      return (
        t.addEventListener("pointerdown", k),
        t.addEventListener("pointermove", T),
        t.addEventListener("pointerleave", w),
        window.addEventListener("pointerup", C),
        window.addEventListener("pointercancel", C),
        () => {
          (N.disconnect(),
            d && cancelAnimationFrame(d),
            c && cancelAnimationFrame(c),
            t.removeEventListener("pointerdown", k),
            t.removeEventListener("pointermove", T),
            t.removeEventListener("pointerleave", w),
            window.removeEventListener("pointerup", C),
            window.removeEventListener("pointercancel", C));
        }
      );
    }, [text]),
    (
      <div ref={containerRef} className={"Hero_particleTextWrap__nV0pL"}>
        <canvas
          ref={canvasRef}
          className={"Hero_particleTextCanvas__nV0pL"}
          aria-hidden={"true"}
        />
      </div>
    )
  );
}
export {
  lineSlotClass,
  lineSizerClass,
  lineTypingClass,
  lineClass,
  particleColor,
  particleFont,
  hexToRgb,
  clamp,
  ParticleText,
};
